import React from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { IField } from '../../Hooks/useField';
import NumberFormat, { NumberFormatProps } from "react-number-format";

export type IntegerFieldProps = TextFieldProps & {
    field: IField
    updateFieldStateOnChange?: boolean
    onValueChanged?: (newValue: any) => void
    onEnter?: React.KeyboardEventHandler<HTMLDivElement> | undefined
    prefix?: string
}

function IntegerFieldComponent ({ 
    field, 
    onValueChanged, 
    updateFieldStateOnChange, 
    onEnter,
    onKeyDown,
    fullWidth, 
    helperText, 
    ...props
}: IntegerFieldProps) {
    const [_value, _setValue] = React.useState(field.value);

    const handleChange = React.useCallback((name: string, value: number | undefined) => {
        _setValue(value);
    }, []);

    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" && onEnter !== undefined) {
            onEnter(e);
        }

        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
    }, [onEnter, onKeyDown]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        field.setInputValue(_value);

        if (onValueChanged !== undefined) {
            onValueChanged(_value);
        }

        if (updateFieldStateOnChange === true && field.value !== _value) {
            field.setValue(_value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        if (field.value !== _value) {
            _setValue(field.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(field.initialValueRef?.current);
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <TextField
            {...props}
            name={field.name}
            //value={_value !== undefined && _value !== null ? _value : ""}
            //onChange={handleChange}
            fullWidth={fullWidth !== false}
            helperText={!!field.error ? field.error : helperText}
            error={!!field.error}
            InputLabelProps={{
                shrink: !! (_value || "0").toString()
            }}
            InputProps={{
                ...props.InputProps,
                value: _value !== undefined && _value !== null ? _value : "",
                onChange: handleChange as any,
                onKeyDown: handleKeyDown as any,
                inputComponent: InternalIntegerField as any
            }}
        />
    );
}

export const IntegerField = React.memo(IntegerFieldComponent);

type InternalIntegerFieldProps = Omit<NumberFormatProps, "onChange"> & {
    onChange: (name: string, value: number | undefined) => void;
    name: string;
    value: any,
    prefix?: string
}

export function InternalIntegerField({ onChange, value, name, prefix, allowNegative, ...props }: InternalIntegerFieldProps) {
    return (
        <NumberFormat 
            {...props}
            value={value}
            name={name}
            onValueChange={values => {
                if (onChange !== undefined) {
                    onChange(name, values.floatValue);
                }
            }}

            isNumericString
            prefix={prefix}
            allowNegative={allowNegative === true}
            thousandSeparator="."
            decimalScale={0}
            decimalSeparator=","
            fixedDecimalScale
        />
    );
}